<label>
    Sort By:
    <select class="input-select" (change)="updatePageSortBy()" [(ngModel)]="selectedSortBy" [ngModelOptions]="{standalone: true}">
        <option value="Default DESC">Default</option>
        <!-- <option value="Price">Alphabetical</option> -->
        <!-- <option value="New">New Products</option> -->
        <option *ngIf="hasValidToken" value="Price ASC">Price (Low to High)</option>
        <option *ngIf="hasValidToken" value="Price DESC">Price (High to Low)</option>
    </select>
</label>



<label>
    Show:
    <select class="input-select" (change)="updatePageResultSize()" [(ngModel)]="selectedSize" [ngModelOptions]="{standalone: true}">
        <option *ngFor="let pageSize of pageSizes" [ngValue]="pageSize" [selected]="pageSize === pageSizes[0]">{{pageSize}}</option>
    </select>
</label>

